import { useCallback } from 'react';
export var useOnSearchQueryChange = function useOnSearchQueryChange(internalValue, internalOptions, setInternalOptions, setSearchQuery, defaultSearchQuery, enableSearchOption) {
  return useCallback(function () {
    var searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultSearchQuery;

    if (!enableSearchOption) {
      return function () {};
    }

    if (!searchQuery) {
      if (setInternalOptions) {
        setInternalOptions(internalOptions);
      }

      return function () {};
    }

    var query = searchQuery.toLowerCase();

    if (setSearchQuery) {
      setSearchQuery(query);
    }

    var matchingOptions = internalOptions.filter(function (option) {
      var label = typeof option.label === 'string' ? option.label.toLowerCase() : option.label;
      return label.toString().indexOf(query) !== -1;
    });

    if (setInternalOptions) {
      setInternalOptions(matchingOptions);
    }

    return function () {};
  }, [setSearchQuery, internalOptions, internalValue, defaultSearchQuery]);
};